import { IGetVenuesResponseData } from 'src/api/getVenues/types';
import { ICreateAttributeRuleDestination } from 'src/api/createAttributeRule';
import { IAttributeRule } from 'src/types/menu.types';
import { IPricingChannel } from 'src/helpers/channels/getPricingChannels';
import {
  getVenueChannelNames,
  getVenueSystemIds,
  isVenueEligibleForChannels,
  NOT_SET_UP_FOR_CHANNELS,
} from 'src/helpers/venueChannelAvailability/venueChannelAvailability';

export interface IExistingRuleDestination {
  extension_instance_id: string;
  venue_id: string;
  rule_id: string;
  rule_name: string;
}

export const CHOOSE_A_CHANNEL_FIRST = 'Choose a channel first';

export const getVenueDestinationState = (
  venue: IGetVenuesResponseData,
  selectedSystemIds: Set<string>,
): { disabled: boolean; subtitle: string } => {
  if (selectedSystemIds.size === 0) {
    return { disabled: true, subtitle: CHOOSE_A_CHANNEL_FIRST };
  }
  if (!isVenueEligibleForChannels(venue, selectedSystemIds)) {
    return { disabled: true, subtitle: NOT_SET_UP_FOR_CHANNELS };
  }
  return { disabled: false, subtitle: getVenueChannelNames(venue, selectedSystemIds).join(', ') };
};

export const buildRuleDestinations = (
  selectedInstanceIds: string[],
  selectedVenueIds: string[],
  venues: IGetVenuesResponseData[],
  channels: IPricingChannel[],
): ICreateAttributeRuleDestination[] => {
  const selectedVenues = venues.filter(({ venue_id }) => selectedVenueIds.includes(venue_id));

  return channels
    .filter(({ extensionInstanceId }) => selectedInstanceIds.includes(extensionInstanceId))
    .map(({ extensionInstanceId, aggregatorId }) => ({
      extension_instance_id: extensionInstanceId,
      venue_ids: selectedVenues
        .filter((venue) => getVenueSystemIds(venue).includes(aggregatorId))
        .map(({ venue_id }) => venue_id),
    }))
    .filter(({ venue_ids }) => venue_ids.length > 0);
};

export const countExistingRulesForVenue = (
  venueId: string,
  selectedInstanceIds: string[],
  existingDestinations: IExistingRuleDestination[],
): number =>
  new Set(
    existingDestinations
      .filter(
        ({ venue_id, extension_instance_id }) =>
          venue_id === venueId && selectedInstanceIds.includes(extension_instance_id),
      )
      .map(({ rule_id }) => rule_id),
  ).size;

export const getExistingRuleDestinations = (attributeRules: IAttributeRule[]): IExistingRuleDestination[] =>
  attributeRules.flatMap(({ attribute_rule_id, name, destinations }) =>
    destinations.flatMap(({ extension_instance_id, venues }) =>
      venues.map(({ venue_id }) => ({ rule_id: attribute_rule_id, rule_name: name, extension_instance_id, venue_id })),
    ),
  );
